export default __webpack_public_path__ + "static/media/ratingStar.0ab2dbdf.svg";